module.exports = __webpack_public_path__ + "static/img/award-3.c399b5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/award-3.jpg
// module id = Pzfg
// module chunks = 1